<template>
  <UTable :rows="plays" :columns="columns" :loading="pending">
    <template #loading-state>
      <div class="flex justify-center py-12">
        <i class="fas fa-spin fa-spinner"></i>
      </div>
    </template>
    <template #inning-data="{ row }">
      {{ row.inning }}
      <span class="capitalize">({{ row.inning_half }})</span>
    </template>
    <template #player_name-data="{ row }">
      <NuxtLink
        v-if="row.player_id"
        :to="`/players/${row.player_id}`"
        class="underline"
      >
        {{ row.player_name }}
      </NuxtLink>
      <span v-else-if="row.player_name">
        {{ row.player_name }}
      </span>
      <span v-else>--</span>
    </template>
    <template #opponent_name-data="{ row }">
      <span v-if="row.inning_half === 'bot' && row.away_team_name">
        {{ row.away_team_name }}
      </span>
      <span v-else-if="row.inning_half === 'top' && row.home_team_name">
        {{ row.home_team_name }}
      </span>
      <span v-else>--</span>
    </template>
    <template #base_state_before-data="{ row }">
      {{ row.base_state_before }}
      <i
        class="fas text-cardinal dark:text-cardinal-500 fa-chevron-right inline-block mx-1"
      ></i>
      {{ row.base_state_after }}
    </template>
    <template #outs_before-data="{ row }">
      {{ row.outs_before }}
      <i
        class="fas text-cardinal dark:text-cardinal-500 fa-chevron-right inline-block mx-1"
      ></i>
      {{ row.outs_after }}
    </template>
    <template #game_stats_id-data="{ row }">
      <a
        :href="`https://www.ncaa.com/game/${row.game_stats_id}/play-by-play`"
        target="_blank"
      >
        <i class="fa-solid fa-arrow-up-right-from-square" />
      </a>
    </template>
  </UTable>
</template>

<script lang="ts" setup>
defineProps<{
  plays: any[];
  columns: any[];
  loading: boolean;
}>();
</script>
